import { ISubscription, TSubscriptionID, isChargebee } from '../types';
import ChargebeeSubscriptionStatus from './ChargebeeSubscriptionStatus';
import LegacySubscriptionStatus from './LegacySubscriptionStatus';
import './SubscriptionListItem.scss';

export interface ISubscriptionListItemProps {
  subscription: ISubscription;
  onTerminateSubscription: (id: TSubscriptionID) => void;
}

export default function SubscriptionListItem({
  subscription,
  onTerminateSubscription,
}: Readonly<ISubscriptionListItemProps>) {
  const { autoRenewing } = subscription;
  const classNames = `subscription ${autoRenewing ? 'active' : 'terminated'}`;

  const subscriptionStatus = isChargebee(subscription) ? (
    <ChargebeeSubscriptionStatus subscription={subscription} onTerminateSubscription={onTerminateSubscription} />
  ) : (
    <LegacySubscriptionStatus subscription={subscription} onTerminateSubscription={onTerminateSubscription} />
  );
  return (
    <div className={classNames} data-testid="subscriptions-list-item">
      {subscriptionStatus}
    </div>
  );
}
